<div class="filter areas-tab" ngModelGroup="areaGroup" #area="ngModelGroup">
  <div *ngIf="isMunicipalityLoading && isAdmin">
    <app-filter-item [title]="'Municipality'" [value]="departmentValue" [clearFilter]="clearFilter('departmentId')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select name="departmentId"
          placeholder="Municipality"
          [disabled]="!isAdmin"
          [ngModel]="areaGroup.departmentId"
          (ngModelChange)="onDepartmentChange($event)"
        >
          <mat-option *ngFor="let option of departmentOptions" [value]="option.value">
            {{option.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </app-filter-item>
  </div>
  <div class="filter__column-breaker_large">
    <app-filter-item [title]="'Zip Code'" [value]="zipCodesValue" [clearFilter]="clearFilter('zipCodes')">
      <app-multiselect-with-search
        name="zipCodes"
        [placeholder]="isLoading ? 'Loading...' : 'Zip Code'"
        [options]="zipCodeOptions"
        [(ngModel)]="areaGroup.zipCodes"
      />
    </app-filter-item>
  </div>
  <div class="filter__column-breaker_medium">
    <app-filter-item [title]="'City'" [value]="citiesValue" [clearFilter]="clearFilter('cities')">
        <app-multiselect-with-search
          name="cities"
          [placeholder]="isLoading ? 'Loading...' : 'City'"
          [options]="cityOptions"
          [(ngModel)]="areaGroup.cities"
        />
    </app-filter-item>
  </div>
  <div class="filter__column-breaker_large" *ngIf="isMunicipalityLoading">
    <app-filter-item [title]="'Service Area'" [value]="substation" [clearFilter]="clearFilter('substation')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select disabled [value]="substation" placeholder="Service Area" />
      </mat-form-field>
    </app-filter-item>
  </div>
  <div *ngIf="isMunicipalityLoading">
    <app-filter-item [title]="'Council District'" [value]="councilDistrict"
                     [clearFilter]="clearFilter('councilDistrict')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select disabled [value]="councilDistrict" placeholder="Council District" />
      </mat-form-field>
    </app-filter-item>
  </div>
  <div *ngIf="isMunicipalityLoading">
    <app-filter-item [title]="'Patrol District'" [value]="sapdDistrict"
                     [clearFilter]="clearFilter('sapdDistrict')">
      <mat-form-field appearance="outline" class="filter__select_full">
        <mat-select disabled [value]="sapdDistrict" placeholder="Patrol District" />
      </mat-form-field>
    </app-filter-item>
  </div>
  <div class="column-occupier"></div>
</div>
